// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api.js";
import ResponseChecker from "../Middlewares/ResponseChecker.js";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints/index.js";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

//ENUMS
// eslint-disable-next-line no-unused-vars
import { BatterySort } from "@/enums/Battery/BatterySort.js";
// eslint-disable-next-line no-unused-vars
import { BatteryType } from "@/enums/Battery/BatteryType.js";

// ## Battery Get
/**
 *
 * @param {{params: object, query: { page: number, limit: number, sortBy: BatterySort, sortOrder: 'ASC' | 'DESC', type: BatteryType, isLocked: boolean, userId: number }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.ProjectPermissions.GetAll(option));

  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## Battery Create
/**
 *
 * @param {{"authorizedUserId": number,"batteryId": number }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.ProjectPermissions.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Battery Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.ProjectPermissions.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Battery Update
/**
 *
 * @param  {{ "name": "string", "surname": "string", "email": "user@example.com", "phoneNo": "string", "password": "string", "role": BatteryRole}} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(
    Endpoints.ProjectPermissions.Update(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Battery Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(
    Endpoints.ProjectPermissions.Delete(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Battery Create
/**
 *
 * @param {{ query: { batteryId: string, limit: number, page: number }, params: object}} option
 *
 * @returns
 */
export const GetProjectPermissionUsers = async (option) => {
  const response = await $api.get(
    Endpoints.ProjectPermissions.GetProjectPermissionUsers(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
  GetProjectPermissionUsers,
};
